var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status-pill",class:[_vm.optedOut ? 'opted-out' : 'opted-in'],on:{"click":_vm.statusClicked}},[_vm._v(" "+_vm._s(_vm.optedOut ? 'Opted Out' : 'Opted In')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }